import { Routes, Route, Navigate } from 'react-router-dom';
import Admin from '../../admin/Admin';
import AdminServices from '../../admin/services';
import AdminStaff from '../../admin/staff';
import AdminAvailability from '../../admin/availability';
import AdminServiceBookings from '../../admin/serviceBookings';
import Users from '../../admin/users';
import Transactions from '../../admin/transactions';
import DiscountCodes from '../../admin/discountCodes';
import AdminSettings from '../../admin/settings';
import WalletPackages from '../../admin/walletPackages';
import WalletTransactions from '../../admin/walletTransactions';

const VariableAdminRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Admin />}>
                <Route path="services" element={<AdminServices.Template />}>
                    <Route path="" element={<AdminServices.List />} />
                    <Route path="create" element={<AdminServices.Create />} />
                    <Route path=":id" element={<AdminServices.Update />} />
                </Route>
                <Route path="staff" element={<AdminStaff.Template />}>
                    <Route path="" element={<AdminStaff.List />} />
                    <Route path="create" element={<AdminStaff.Create />} />
                    <Route path=":id" element={<AdminStaff.Update />} />
                </Route>
                <Route path="staff/:id/report" element={<AdminStaff.Report />} />
                <Route path="availability" element={<AdminAvailability.Template />}>
                    <Route path="" element={<AdminAvailability.Manage />} />
                </Route>
                <Route path="service-bookings" element={<AdminServiceBookings.Template />}>
                    <Route path="" element={<AdminServiceBookings.List />} />
                    <Route path=":id" element={<AdminServiceBookings.Existing />} />
                </Route>
                <Route path="users" element={<Users.Template />}>
                    <Route path="" element={<Users.List />} />
                    <Route path=":id" element={<Users.Existing />} />
                </Route>
                <Route path="transactions" element={<Transactions.Template />}>
                    <Route path="" element={<Transactions.List />} />
                    <Route path="create" element={<Transactions.Create />} />
                    <Route path=":id" element={<Transactions.Existing />} />
                </Route>
                <Route path="discount-codes" element={<DiscountCodes.Template />}>
                    <Route path="" element={<DiscountCodes.List />} />
                    <Route path="create" element={<DiscountCodes.Create />} />
                    <Route path=":id" element={<DiscountCodes.Update />} />
                </Route>
                <Route path="wallet-packages" element={<WalletPackages.Template />}>
                    <Route path="" element={<WalletPackages.List />} />
                    <Route path="create" element={<WalletPackages.Create />} />
                    <Route path=":id" element={<WalletPackages.Update />} />
                </Route>
                <Route path="wallet-transactions" element={<WalletTransactions.Template />}>
                    <Route path="" element={<WalletTransactions.List />} />
                </Route>
                <Route path="settings" element={<AdminSettings.Template />}>
                    <Route path="" element={<AdminSettings.Settings />} />
                </Route>
                <Route path="/" element={<Navigate to="/admin/services" />} />
            </Route>
        </Routes>
    );
};

export default VariableAdminRouter;
